export default __webpack_public_path__ + "static/media/back.d2ac1e5f.svg";